var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectInboxBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "direct-inbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1.33333V6L9.33333 4.66667",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 6L6.66667 4.66667",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.32 8.66667H4.26C4.51333 8.66667 4.74 8.80667 4.85333 9.03333L5.63333 10.5933C5.86 11.0467 6.32 11.3333 6.82667 11.3333H9.18C9.68667 11.3333 10.1467 11.0467 10.3733 10.5933L11.1533 9.03333C11.2667 8.80667 11.5 8.66667 11.7467 8.66667H14.6533",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.66667 2.75333C2.30667 3.1 1.33333 4.48667 1.33333 7.33333V10C1.33333 13.3333 2.66667 14.6667 6 14.6667H10C13.3333 14.6667 14.6667 13.3333 14.6667 10V7.33333C14.6667 4.48667 13.6933 3.1 11.3333 2.75333",
    stroke: "#1E5AD2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0,
    d: "M15.3496 0.650391V15.3496H0.650391V0.650391H15.3496Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectInboxBlue);
export default __webpack_public_path__ + "static/media/direct-inbox-blue.48ee0a99e88d59d40fdb5a2c6864ab58.svg";
export { ForwardRef as ReactComponent };